import React, {useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import {createSpinnerWave} from 'embo/ui/spinner-wave'


const SIZES = {
  sm: {viewBoxWidth: 240, viewBoxHeight: 60, wavelengths: 2.5, amplitude: 8},
  md: {viewBoxWidth: 240, viewBoxHeight: 60, wavelengths: 2.5, amplitude: 12},
}

const Wave = ({
  size = 'sm',
  spinning = true,
  error = false,
}) => {
  const svgRef = useRef(null)
  const waveRef = useRef(null)
  const classes = cn('spinner-wave', `spinner-wave--${size}`, {
    'spinner-wave--error': error,
  })

  useEffect(() => {
    waveRef.current = createSpinnerWave(svgRef.current, SIZES[size])
    if (spinning) waveRef.current.start()
    return () => waveRef.current.stop()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (spinning) waveRef.current.start()
    else waveRef.current.stop()
  }, [spinning])

  return (
    <div className={classes}>
      <svg ref={svgRef} className="spinner-wave__svg" preserveAspectRatio="none" aria-hidden="true">
        <path className="spinner-wave__path"/>
      </svg>
    </div>
  )
}
Wave.propTypes = {
  size: PropTypes.oneOf(Object.keys(SIZES)),
  spinning: PropTypes.bool,
  error: PropTypes.bool,
}

export default React.memo(Wave)
